/** The sample data layer. */

import { ApiError, type LocalApi } from '@metal/ui/api'

const LIVE_PREFIXES = ['/auth/', '/registration/', '/onboarding/', '/kyc/', '/admin/kyc/']
const LIVE_ROOTS = ['/consents', '/notifications']
const LIVE_EXACT = ['/me', '/me/capabilities', '/me/notification-preferences', '/market/clock']

export function isLive(path: string): boolean {
  return (
    LIVE_EXACT.includes(path) ||
    LIVE_PREFIXES.some((p) => path.startsWith(p)) ||
    LIVE_ROOTS.some((p) => path === p || path.startsWith(`${p}/`))
  )
}

/** A file behind a link: a signed download, an export, a printable sheet. */
const FILE_ROUTE = /\/(download|export|print)$/

/** The path and its query, keys sorted and empty values dropped. */
export function sampleKey(path: string, query: URLSearchParams): string {
  const entries = [...query].filter(([, v]) => v !== '')
  entries.sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
  const q = new URLSearchParams(entries).toString()
  return q ? `${path}?${q}` : path
}

type Samples = Record<string, unknown>
let samples: Promise<Samples> | null = null

function load(): Promise<Samples> {
  samples ??= import('./sample-data.json?raw').then((m) => JSON.parse(m.default) as Samples)
  return samples
}

function refusal(status: number, code: string, message: string): Promise<never> {
  return Promise.reject(new ApiError(status, { code, message, traceId: '-' }))
}

export const localApi: LocalApi = ({ method, path, query, kind }) => {
  if (isLive(path)) return undefined
  if (method !== 'GET' || kind !== 'json' || FILE_ROUTE.test(path)) {
    return refusal(403, 'NOT_AVAILABLE', 'این بخش هنوز فعال نشده است.')
  }
  const key = sampleKey(path, query)
  return load().then((all) => {
    const hit = key in all ? all[key] : path in all ? all[path] : undefined
    if (hit === undefined) return refusal(404, 'NOT_FOUND', 'یافت نشد.')
    return structuredClone(hit)
  })
}
